import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { apiService } from './apiService';

export type MobileVersionCheckResult = {
  platform: 'android' | 'ios';
  currentVersion: string;
  latestVersion: string;
  updateAvailable: boolean;
  forceUpdate: boolean;
  storeUrl: string;
  message: string;
};

const APP_PACKAGE_ID = 'com.doguscay.yukortagim';

export const appUpdateService = {
  async checkForUpdate(): Promise<MobileVersionCheckResult | null> {
    if (!Capacitor.isNativePlatform()) return null;

    const platform = Capacitor.getPlatform();
    if (platform !== 'android' && platform !== 'ios') return null;

    const info = await App.getInfo();
    const currentVersion = String(info.version || '').trim();
    if (!currentVersion) return null;

    const query = new URLSearchParams({
      platform,
      currentVersion,
      packageId: info.id || APP_PACKAGE_ID,
      build: info.build || '',
    });

    const response = await apiService.get<MobileVersionCheckResult>(`/settings/public/mobile-version-check?${query.toString()}`, { timeoutMs: 15000 });
    return response.data || null;
  },

  openStore(url?: string) {
    if (!url) return;
    window.open(url, '_system', 'noopener,noreferrer');
  },
};
